enum OperationStatus {
    Loading,
    Error,
    Success,
    Idle,
}

export default OperationStatus;
